import { BotonExportarExcel, Group, TablaSkeleton, Table, Tbody, Td, Text, Th, Thead, Tr } from "@/components/ui";
import type { EquivalenciaUnidad } from "@/lib/types";
import { EquivalenciaRow } from "./EquivalenciaRow";

/** Tabla del catálogo de equivalencias · cada fila controla su modo edición. */
export function EquivalenciasTable({
  cargando = false,
  equivalencias,
  obtenerFilasExport,
}: {
  /** Primera carga (sin caché) · filas skeleton bajo el encabezado real. */
  cargando?: boolean;
  equivalencias: EquivalenciaUnidad[];
  /** Con paginado server-side: callback que trae TODAS las páginas para el export. */
  obtenerFilasExport?: () => Promise<EquivalenciaUnidad[]>;
}) {
  return (
    <div className="overflow-x-auto">
      <Group justify="flex-end" className="mb-2">
        <BotonExportarExcel
          archivo="equivalencias-unidad"
          hoja="Equivalencias"
          filas={obtenerFilasExport ? undefined : equivalencias}
          obtenerFilas={obtenerFilasExport}
          columnas={[
            { header: "Clave SAT", value: (e) => e.claveUnidadSat },
            { header: "Unidad SAP", value: (e) => e.unidadSap },
            { header: "Descripción", value: (e) => e.descripcion },
            { header: "Estado", value: (e) => (e.activo ? "Activa" : "Inactiva") },
          ]}
        />
      </Group>
      <Table verticalSpacing="sm">
        <Thead>
          <Tr>
            <Th>Clave SAT</Th>
            <Th>Unidad SAP</Th>
            <Th>Descripción</Th>
            <Th>Estado</Th>
            <Th />
          </Tr>
        </Thead>
        {cargando ? (
          <TablaSkeleton dentroDeTabla columnas={[{}, {}, {}, {}, { align: "right" }]} filas={15} />
        ) : (
          <Tbody>
            {equivalencias.map((e) => (
              <EquivalenciaRow key={e.id} equivalencia={e} />
            ))}
            {equivalencias.length === 0 && (
              <Tr>
                <Td colSpan={5}>
                  <Text size="sm" c="dimmed" ta="center" className="py-3">
                    Sin equivalencias. Crea la primera con "Nueva equivalencia".
                  </Text>
                </Td>
              </Tr>
            )}
          </Tbody>
        )}
      </Table>
    </div>
  );
}
